"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ReachedCardWithTimer_1 = __importDefault(require("../ReachedCardWithTimer"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var CoolingOffLimitActive = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useCoolingOffLimit)().data;
    if (!data)
        return null;
    return (react_1.default.createElement(ReachedCardWithTimer_1.default, { title: t('coolingOffLimitReached.title'), disclaimer: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: t('coolingOffLimitReached.description'),
            } }), endDate: data === null || data === void 0 ? void 0 : data.dateTo }));
};
exports.default = CoolingOffLimitActive;
